export const formatPrice = (v) => {
  const n = Math.round(Number(v || 0) * 100) / 100;
  return Number.isInteger(n) ? String(n) : n.toFixed(2);
};
